// extracted by mini-css-extract-plugin
export default {"infoWrapper":"Info_infoWrapper__hVpQg","box":"Info_box__2IE2t","info":"Info_info__76m09"};